module.exports = __webpack_public_path__ + "static/media/avatar.6fd8992d.png";